import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const StressJumbotron = () => {
  return (
    <LandingPageJumbotron
      data-cy="stress-jumbotron"
      description="stress_testimonial_copy"
      theme="purple"
      title="stress_testimonial_eyebrow"
    />
  );
};
export default StressJumbotron;
